import Marquee from "react-fast-marquee";

const BRANDS = [
  "Ceresit", "Baumit", "Graymix", "Caparol", "Kreisel",
  "Weber Terranova", "Isover", "Nobasil", "Rockwool", "Austrotherm", "Easytherm",
];

export default function Brands() {
  return (
    <section id="znacky" className="bg-ink py-16 md:py-20 border-t border-white/10" data-testid="brands-section">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 mb-10">
        <p className="font-mono2 text-gold uppercase tracking-[0.3em] text-xs mb-4">Overené materiály</p>
        <h2 className="font-display text-3xl md:text-5xl leading-[0.95] text-white max-w-3xl">
          Pracujeme len so <span className="text-gold">značkovými materiálmi</span>
        </h2>
        <p className="text-white/50 text-sm md:text-base mt-4 max-w-2xl">
          Zatepľovacie systémy, izolácie a omietky od popredných európskych výrobcov — istota kvality a dlhej životnosti fasády.
        </p>
      </div>
      <Marquee speed={38} gradient={false} autoFill pauseOnHover>
        {BRANDS.map((b, i) => (
          <div
            key={i}
            data-testid={`brand-${b.toLowerCase().replace(/\s+/g, "-")}`}
            className="mx-3 md:mx-4 px-7 py-4 border border-white/15 bg-ink-2 hover:border-gold/60 hover:bg-gold/5 transition-colors"
          >
            <span className="font-display text-2xl md:text-3xl text-white/80 tracking-wide whitespace-nowrap">{b}</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
}
